var RelaxComponent;

(function ($, utils) {

	var RelaxDetailComponent = Vue.component('relax-detail-vue', {
		template: '#relax-detail-vue',
		props: ['values', 'showDetail', 'closeDetail']
	});

	RelaxComponent = Vue.component('relax-vue', {
		template: '#relax-vue',
		data: function() {
			return {
				id: '',
				storeFloor: '',
				values: [],
				hideSpinner: false
			}
		},
		components: {
			RelaxDetailComponent: RelaxDetailComponent
		},

		mounted: function() {
			this.mobile();
		},

		methods: {
			mobile: function() {
				var $detailCafe = $('.blockRelax__detail'),
					isMobile = function() {
					if (app.sizes.width < app.mobileTo) $('.content').append($detailCafe);
				};

				isMobile();
			},

			gotoMap: function() {
	      var arr = {
	        id: '',
	        floor: ''
	      };
	      arr.id = this.id;
	      arr.floor = this.storeFloor;
	      return arr;
	    },

	    getDataArr: function(storeId, floor) {
	      this.id   = storeId;
	      this.storeFloor  = floor;
	    },

			getData: function() {
				var url = '/static/components-assets/blockRelax/data.json';

				if(CommonHelpers.isDev('gold-babylon-static.denode.ru'))
					url = 'static/components-assets/blockRelax/data.json';

				// todo сделать localstorage
				if(!this.values.length) {
					this.$http
						.get(url, {
							params: {
								action: 'getRelax'
							}
						})
						.then(function(response) {
								var data  = response.body.data,
										that 	= this;

								this.values = data;

								var objImages = []; // массив со ссылками изображений


								$.each(data, function(i, item) {
									var newObj = {
										loaded: false,
										src: item.catImg
									};
									objImages.push(newObj);
								});

								CommonHelpers.checkImgLoading(objImages)
								.then(function() {
									that.doAnimation();
								});

								this.$nextTick(function() {
									this.scriptsInit();
								});
							},
							function(response) { // Error.
								console.log('An error occurred.');
							}
						);
				}
			},

			doAnimation: function() {
				var $targetSlide = $('.blockRelaxSlider');
				$targetSlide.find('.fade-item').showItem(450);

				this.hideSpinner = true;
			},

			showDetail: function(id) {
				var $box = $('.blockRelax__detail'),
					$slider = $box.find('.blockRelaxSlider'),
					$slides = $slider.find('.swiper-slide');

				$box.addClass('open');
				setTimeout(function(){
					$('html, body').addClass('overflow--detail');
				}, 500);

				var swiper = new Swiper($slider.find('.swiper-container'), {
					keyboardControl: true,
					updateOnImagesReady: true,
					slidesPerView: 1,
					effect: 'slide',
					nextButton: $slider.find('.swiper-button-next'),
					prevButton: $slider.find('.swiper-button-prev'),
					onInit: function(){
						$slider.scrollTop(0);
					}
				});

				if (id) {
					var $activeSlide = $slides.filter('[data-id="'+id+'"]'),
						slideTo = $activeSlide.index();

					if (slideTo != 0) swiper.slideTo(slideTo, 0, false);
					else swiper.setWrapperTranslate(0);
				}

				$.each($slides, function(){
					var $slide = $(this),
						$face = $slide.find('.swiper-face'),
						width = $slider.outerWidth();

					$face.outerHeight(width*1.5512);

					$(window).on('resize', function(){
						var width = $slider.outerWidth();

						$face.outerHeight(width*1.5512);
					});
				});
			},

			closeDetail: function() {
				$('html, body').removeClass('overflow--detail');
				$('.blockRelax__detail').removeClass('open');
				$(window).scrollTop($('.box_blockRelax').offset().top - $('.header__left').outerHeight());
			},

			scriptsInit: function() {
				var $box    = $('.box_blockRelax'),
						$slider = $box.find('.blockRelaxSlider'),
						$items  = $slider.find('.js-relax');

				var swiper = new Swiper($slider.find('.swiper-container'), {
					keyboardControl: true,
					updateOnImagesReady: true,
					slidesPerView: 2,
					effect: 'slide',
					nextButton: $slider.find('.swiper-button-next'),
					prevButton: $slider.find('.swiper-button-prev'),
					breakpoints: {
						1020: {
							slidesPerView: 1
						}
					}
				});


				$.each($items, function() {
					var $item  = $(this),
							height = $('.blockRelax__left').outerHeight(),
							$face  = $item.find('.swiper-face'),
							$backface = $item.find('.swiper-backface'),
							$close = $item.find('.close'),
							$gotoMap = $item.find('.js-gotoMap'),
							width = $face.outerWidth();


					if (app.sizes.width > app.mobileTo) { // for desktop

						$face.outerHeight(width*1.5512).css({top: (height-(width*1.5512))/2 });
						$backface.outerHeight(width*1.5512).css({top: (height-(width*1.5512))/2 });

						$(window).on('resize', function(){
							var height = $('.blockRelax__left').outerHeight(),
								width = $face.outerWidth();

							$face.outerHeight(width*1.5512).css({top: (height-(width*1.5512))/2 });
							$backface.outerHeight(width*1.5512).css({top: (height-(width*1.5512))/2 });
						});

						$face.on('click', function() {
							$items.removeClass('active');
							$item.addClass('active');
						});
						$close.on('click', function() {
							$item.removeClass('active');
						});
						// Переход к карте в тултипе
						$gotoMap.on('click', function() {
							var arr = vueApp.$refs.relax.gotoMap();
							CommonHelpers.searchMap(null, arr);
						});

					} else { // for mobile
						var width = $('.blockRelax__left').outerWidth();

						$face.outerHeight((width*1.5512) + 100);
						$backface.outerHeight((width*1.5512) + 100);

						$(window).on('resize', function(){
							var width = $('.blockRelax__left').outerWidth();

							$face.outerHeight((width*1.5512) + 100);
							$backface.outerHeight((width*1.5512) + 100);
						});
					}
				});
			}
		}
	});
})(jQuery, app.utils);